export default "__VITE_ASSET__Bj5parqT__"